module.exports = __webpack_public_path__ + "img/icon-cocktail.f7011fb9.svg";